import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Dropdown from 'react-bootstrap/Dropdown'; // Import Dropdown component
import './megamenu.css';

function BasicExample({ showNav, setShowNav }) {
  // const { showNav, setShowNav } = props;
  const [hoveredDropdown, setHoveredDropdown] = useState(null);

  function toggleNav() {
    setShowNav(!showNav);
  }

  function handleMouseEnter(eventKey) {
    setHoveredDropdown(eventKey);
  }

  function handleMouseLeave() {
    setHoveredDropdown(null);
  }

  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container className='sidebar'>
        <Navbar.Brand aria-label='Narbar Home' href="#home">{""}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={toggleNav} />
        <Navbar.Collapse id="basic-navbar-nav" className={!showNav && ' d-none'}>
          <Nav className="newDD me-auto">

            {/* 1. Home */}
            <Nav.Item className="nav-link">
              <Link to='/' role='button' >
                <i className='fas fa-home'></i>
              </Link>
            </Nav.Item>



            {/**************** 2. Institute ***************/}

            <NavDropdown
              className="align-text-top basic-nav-dropdown needScroll"
              onMouseEnter={() => handleMouseEnter("institute")}
              onMouseLeave={handleMouseLeave}
              show={hoveredDropdown === "institute"}
              title="संस्थान"
            >
              {/* <span className="nav-link">Institute</span> */}
              {hoveredDropdown === "institute" && (
              <div className="eventsNav ">
                {/* <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s"> */}
                  <div className='has-border '>
                    
                    <Dropdown.Header>आईआईटी के बारे में</Dropdown.Header>
                    <Link to="/aboutus" className="dropdown-item nav-link">हमारे बारे में</Link>
                    {/* <Link to="/mission-vision" className="dropdown-item nav-link">Vision & Mission</Link> */}
                    <Link to="/permanent-campus" className="dropdown-item nav-link">परिसर का मानचित्र</Link>
                    <Link to="/newsletter" className="dropdown-item nav-link">आईआईटी समाचार पत्र</Link>
                  </div>
                  <div className='has-border'>
                    <Dropdown.Header>प्रशासन</Dropdown.Header>
                    <Link to="/board-of-governors" className="dropdown-item nav-link">शासी मंडल</Link>
                    <Link to="/acad-admin" className="dropdown-item nav-link">शैक्षणिक प्रशासन</Link>
                    <Link to="/senate" className="dropdown-item nav-link">सिनेट (विद्वत परिषद)</Link>
                    <Link to="/finance-committee" className="dropdown-item nav-link">वित्त समिति</Link>
                    <Link to="/building-and-work-commitee" className="dropdown-item nav-link">भवन और निर्माण समिति</Link>
                    <Link to="/organizational-structure" className="dropdown-item nav-link">संगठनात्मक संरचना</Link>
                    <Link to="/rti" className="dropdown-item nav-link">सूचना का अधिकार</Link>
                    <Link to="/internalcomplaintcommittee" className="dropdown-item nav-link">आंतरिक शिकायत समिति</Link>
                    <Link to="/liaison-officers" className="dropdown-item nav-link">एससी/एसटी/ओबीसी संपर्क अधिकारी/सेल</Link>
                  </div>

                  <div className='has-border'>
                    <Dropdown.Header>प्रतिवेदन</Dropdown.Header>
                    <Link to="/annualreports" className="dropdown-item nav-link">लेखापरीक्षा और वार्षिक प्रतिवेदन</Link>
                    <Link to="/rti-section-4" className="dropdown-item nav-link">अधिनियम और कानून</Link>
                    {/* <Link to="/policies" className="dropdown-item nav-link">गुणवत्ता नीति</Link> */}
                    {/* Add other links */}
                  </div>
                  {/* Add other dropdown sections */}
                </div>
              )}
            </NavDropdown>

           

            {/**************** 3. Academics ***************/}

            <NavDropdown
              className="align-text-top basic-nav-dropdown needScroll needScrollTablet"
              onMouseEnter={() => handleMouseEnter("Academics")}
              onMouseLeave={handleMouseLeave}
              show={hoveredDropdown === "Academics"}
              title="शैक्षणिक"
            >
              {/* <span className="nav-link">Academics</span> */}

                {hoveredDropdown === "Academics" && (
                // <div className="eventsNav  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                <div className="eventsNav ">
                  {/* <div className='has-border'>
                    <Dropdown.Header>Admissions</Dropdown.Header>
                    <Link to="/admissions" className="dropdown-item nav-link">Admissions</Link>
                    <Link to="/ph-d-admission" className="dropdown-item nav-link">Ph.D.</Link>
                    <Link to="/ms-admission" className="dropdown-item nav-link">M.S. (Research)</Link>
                    <Link to="/ms-phd-international" className="dropdown-item nav-link">M.S./Ph.D. International</Link>
                    <Link to="/m-tech-admission" className="dropdown-item nav-link">M.Tech</Link>
                    <Link to="/m-sc-admission" className="dropdown-item nav-link">M.Sc</Link>
                    <Link to="/master-of-public-policy-mpp-admission" className="dropdown-item nav-link">Master of Public Policy (MPP)</Link>
                    <Link to="/b-tech-admission" className="dropdown-item nav-link">B.Tech</Link>
                  </div> */}
                  <div className='has-border'>
                    <Dropdown.Header>विभाग</Dropdown.Header>
                    <Link to="https://chemical.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">रासायनिक अभियांत्रिकी</Link>
                    <Link to="https://cy.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">रसायन विज्ञान</Link>
                    <Link to="https://cee.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">सिविल और पर्यावरण अभियांत्रिकी</Link>
                    <Link to="https://cse.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">कंप्यूटर विज्ञान & अभियांत्रिकी</Link>
                    <Link to="https://ee.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">विद्युत अभियांत्रिकी</Link>
                    <Link to="https://hss.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">मानविकी और समाज विज्ञान</Link>
                    <Link to="https://mast.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">गणित और सांख्यिकी</Link>
                    <Link to="https://mech.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">यांत्रिक अभियांत्रिकी</Link>
                    <Link to="https://physics.iittp.ac.in/" target='_blank' className="dropdown-item nav-link">भौतिक विज्ञान</Link>
                  </div>
                  <div className='has-border'>
                    <Dropdown.Header>कार्यक्रम</Dropdown.Header>
                    <Link to="/admissions" className="dropdown-item nav-link">प्रवेश</Link>
                    <Link to="/phd" className="dropdown-item nav-link">पीएच. डी.</Link>
                    <Link to="/ms" className="dropdown-item nav-link">एमएस. शोध.</Link>
                    <Link to="/mtech" className="dropdown-item nav-link">एम. टेक.</Link>
                    <Link to="/msc" className="dropdown-item nav-link">एम. एससी.</Link>
                    <Link to="/master-of-public-policy-mpp" className="dropdown-item nav-link">लोक नीति - स्नातकोत्तर</Link>
                    <Link to="/btech" className="dropdown-item nav-link">बी. टेक</Link>
                    <Link to="/ms-phd-international" className="dropdown-item nav-link">अंतर्राष्ट्रीय एम. एस/पीएच. डी.</Link>
                    <Link to="/m-tech-international" className="dropdown-item nav-link">अंतर्राष्ट्रीय एम. टेक</Link>
                    {/* </div>
                    <div className='has-border'> */}
                    
                    {/* <Link to='https://www.onlinesbi.sbi/sbicollect/icollecthome.htm?corpID=646389' className="dropdown-item nav-link">Fee Payment</Link> */}
                  </div>
                  
                  <div className='has-border'>
                    <Dropdown.Header>छात्रवृत्ति</Dropdown.Header>
                    <Link to='/institute-scholarships' className="dropdown-item nav-link">संस्थान छात्रवृत्ति</Link>
                    <Link to='https://scholarships.gov.in/' target='_blank' className="dropdown-item nav-link">राष्ट्रीय छात्रवृत्ति पोर्टल</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Scholarship Calendar <i className="fas fa-uc"></i></Link> */}
                    <Link to='/bonafides-scholarship-forms' className="dropdown-item nav-link">प्रामाणिकता & छात्रवृत्ति फॉर्म</Link>
                    {/* </div>
                    <div className='has-border'> */}
                    <Dropdown.Header>अन्य अध्येतावृत्ति</Dropdown.Header>
                    <Link to='https://www.ugc.gov.in/pdfnews/8821047_revised-JRF.pdf' target='_blank' className="dropdown-item nav-link">यूजीसी दिशानिर्देश</Link>
                    <Link to='https://csirhrdg.res.in/Home/Index/1/Default/2971/60' target='_blank' className="dropdown-item nav-link">सीएसआईआर दिशानिर्देश</Link>
                    {/* TODO : Enable these pages */}
                    <Link to='/pmrf-scholars' className="dropdown-item nav-link">पीएमआरएफ</Link>
                    <Link to='/prime-minister-s-fellowship' className="dropdown-item nav-link">प्रधानमंत्री अध्येतावृत्ति</Link>
                    <Dropdown.Header>शुल्क</Dropdown.Header>
                    <Link to='/fee-structure' className="dropdown-item nav-link">शुल्क संरचना</Link>
                    <Link to='/statement-of-expenditure' className="dropdown-item nav-link">व्यय का विवरण</Link>
                  </div>
                  <div className='has-border'>
                    <Dropdown.Header>शैक्षिक संसाधन</Dropdown.Header>
                    <Link to='/academic-calender' className="dropdown-item nav-link">अकादमिक कैलंडर</Link>
                    <Link to='/b-tech-curriculum' className="dropdown-item nav-link">पाठ्यक्रम</Link>
                    <Link to='/syllabus' className="dropdown-item nav-link">पाठ्य विवरण</Link>
                    <Link to='/btechtimetable' className="dropdown-item nav-link">समय सारणी (बी. टेक)</Link>
                    <Link to='/timetable-pg' className="dropdown-item nav-link">समय सारणी (पी जी)</Link>
                    <Link to='/academic-forms' className="dropdown-item nav-link">प्रपत्र</Link>
                    <Link to='/ordinances' className="dropdown-item nav-link">अध्यादेश</Link>
                    <Link to='/academic-services' className="dropdown-item nav-link">शैक्षणिक सेवाएँ</Link>
                    <Link to='https://old.iittp.ac.in/moodle' className="dropdown-item nav-link">मूडल</Link>
                    <Link to='/academic-team' className="dropdown-item nav-link">शैक्षणिक टीम</Link>
                    <Link to='https://files.iittp.ac.in/pdfs/btechthesis/IITTirupatiThesisProjectSynopsis.zip' className="dropdown-item nav-link">परियोजना शोध प्रबंध टेम्पलट</Link>
                    <Dropdown.Header>केंद्र और सुविधाएँ</Dropdown.Header>
                    <Link to='/CentralLibrary' target='_blank' className="dropdown-item nav-link">केन्द्रीय पुस्तकालय</Link>
                    
                  </div>

                </div>
              )}
            </NavDropdown>



            {/**************** 4. Research ***************/}


              <NavDropdown
              className="align-text-top basic-nav-dropdown needScroll"
                onMouseEnter={() => handleMouseEnter("Research")}
                onMouseLeave={handleMouseLeave}
                show={hoveredDropdown === "Research"}
                title="शोध"
              >

              {/* <span className="nav-link">Research</span> */}
              {hoveredDropdown === "Research" && (
                // <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                  <div className="eventsNav ">
                    <div className='has-border'>
                      <Dropdown.Header>शोध</Dropdown.Header>
                      <Link to='https://oia.iittp.ac.in/' target='_blank' className="dropdown-item nav-link">ओआईए</Link>
                      <Link to='https://iittp.ac.in/iic/' target='_blank' className="dropdown-item nav-link">आईआईसी</Link>
                      <Link to='http://10.21.24.53/' target='_blank' className="dropdown-item nav-link">सीएसआरसी वेबसाईट (इंट्रानेट)</Link>
                      <Link to='/research-thrust-areas' className="dropdown-item nav-link">प्रमुख क्षेत्र</Link>
                      <Link to='/research-projects' className="dropdown-item nav-link">शोध परियोजनाएं</Link>
                      <Link to='/research-equipment' className="dropdown-item nav-link">शोध उपकरण</Link>
                      <Link to='https://files.iittp.ac.in/pdfs/IPR%20Policy.pdf' target='_blank' className="dropdown-item nav-link">आईपीआर नीति</Link>
                      <Link to='/incubation' className="dropdown-item nav-link">उद्भवन और उद्यमशीलता</Link>
                      <Link to='/patent-technology-transfer' className="dropdown-item nav-link">एकस्व और प्रौद्योगिकी हस्तांतरण</Link>
                      <Link to='https://iittnif.com' target='_blank' className="dropdown-item nav-link">प्रौद्योगिकी नवाचार केंद्र</Link>
                      {/* <Link to="/coming-soon" className="dropdown-item nav-link">CoE <i className="fas fa-uc"></i></Link> */}
                    </div>
                </div>
              )}
            </NavDropdown>


            {/**************** 5. People ***************/}


              <NavDropdown
                className="align-text-top basic-nav-dropdown"
                onMouseEnter={() => handleMouseEnter("People")}
                onMouseLeave={handleMouseLeave}
                show={hoveredDropdown === "People"}
                title="लोग"
              >

              {/* <span className="nav-link">People</span> */}
              {hoveredDropdown === "People" && (
                // <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                  <div className="eventsNav ">
                  <div className="has-border">
                    <Dropdown.Header>लोग</Dropdown.Header>
                    <Link to='/chemical-engineering-department' className="dropdown-item nav-link">संकाय</Link>
                    <Link to='/admin-staff' className="dropdown-item nav-link">कर्मचारी</Link>
                  </div>
                </div>
              )}
            </NavDropdown>


            {/**************** 6. Campus Life ***************/}


      


              <NavDropdown
              className="align-text-top basic-nav-dropdown needScroll"
                onMouseEnter={() => handleMouseEnter("Campus Life")}
                onMouseLeave={handleMouseLeave}
                show={hoveredDropdown === "Campus Life"}
                title="परिसर जीवन"
              >

              {/* <span className="nav-link">Campus Life</span> */}
              {hoveredDropdown === "Campus Life" && (
                // <div className="eventsNav  wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                <div className="eventsNav ">
                  <div className="has-border" >
                    <Dropdown.Header>गतिविधियां</Dropdown.Header>
                    <Link to='/cultural' className="dropdown-item nav-link">सांस्कृतिक</Link>
                    <Link to='/clubs' className="dropdown-item nav-link">क्लब</Link>
                    <Link to='/festivals' className="dropdown-item nav-link">त्योहार</Link>
                    <Link to='/219-sports-2' className="dropdown-item nav-link">खेलकुद</Link>
                    <Link to='/220-social' className="dropdown-item nav-link">सामाजिक</Link>
                    <Dropdown.Divider />
                    <Link to='https://iittp.ac.in/nss/' target='_blank' className="dropdown-item nav-link">एनएसएस</Link>
                    <Link to='https://iittp.ac.in/medha' target='_blank' className="dropdown-item nav-link">मेधा</Link>
                    <Link to='https://iittp.ac.in/spicmacay' target='_blank' className="dropdown-item nav-link">स्पिक मैके</Link>

                    <Dropdown.Header>विद्यालय</Dropdown.Header>
                    {/* <Link to='/coming-soon' className="dropdown-item nav-link">Kendriya Vidyalaya <i className="fas fa-uc"></i></Link> */}
                    {/* <Link to='/coming-soon' className="dropdown-item nav-link">Little Elly <i className="fas fa-uc"></i></Link> */}
                    <Link to='/creche' className="dropdown-item nav-link">शिशु गृह</Link>
                    <Link to='/kvsiittcampus' className="dropdown-item nav-link">केवि आईआईटी तिरुपति कैंपस</Link>
                  </div>
                  <div className="has-border" >
                    <Dropdown.Header>सुविधाएं</Dropdown.Header>
                    <Link to='https://iittp.ac.in/CentralLibrary' target='_blank' className="dropdown-item nav-link">केन्द्रीय पुस्तकालय</Link>
                    <Link to='https://cc.iittp.ac.in/' target='_blank' className="dropdown-item nav-link">कंप्यूटर केंद्र</Link>
                    <Link to='/health-center' className="dropdown-item nav-link">स्वास्थ्य केंद्र</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">CIF <i className="fas fa-uc"></i></Link> */}
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Central Workshop <i className="fas fa-uc"></i></Link> */}
                    <Link to='https://iittp.ac.in/hostel' target='_blank' className="dropdown-item nav-link">छात्रावास और भोजन संबंधी स्थापना</Link>
                    <Link to='https://cdc.iittp.ac.in/' target='_blank' className="dropdown-item nav-link">कैरियर विकास केंद्र</Link>
                    <Link to='https://iittp.ac.in/gcu' target='_blank' className="dropdown-item nav-link">मार्गदर्शन और परामर्श इकाई</Link>
                    <Link to='/anti-ragging' className="dropdown-item nav-link">एंटी रैगिंग समिति</Link>
                    <Link to='/internalcomplaintcommittee' className="dropdown-item nav-link">आंतरिक शिकायत समिति <br/>(यौन उत्पीड़न के विरुद्ध)</Link>
                    <Link to='https://files.iittp.ac.in/images/demo/iit/pdfs/2018/StudentsConstitution.pdf' target='_blank' className="dropdown-item nav-link">छात्र संविधान</Link>
                    <Link to='/help-desk-girl-students' className="dropdown-item nav-link">सहायता केंद्र @ छात्राएँ</Link>
                    <Link to='/transportation' className="dropdown-item nav-link">परिवहन</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Gymkhana <i className="fas fa-uc"></i></Link> */}
                  </div>

                </div>
              )}
            </NavDropdown>


            {/**************** 7. Resources ***************/}


            <NavDropdown
              className="align-text-top basic-nav-dropdown"
              onMouseEnter={() => handleMouseEnter("Resources")}
              onMouseLeave={handleMouseLeave}
              show={hoveredDropdown === "Resources"}
              title="संसाधन"
            >

              {/* <span className="nav-link">Resources</span> */}
              {hoveredDropdown === "Resources" && (
                // <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                  <div className="eventsNav ">
                  <div className="has-border">
                    <Dropdown.Header>त्वरित संपर्क</Dropdown.Header>
                    {/* <Dropdown.Header>Media</Dropdown.Header> */}
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">IITTP Press Release <i className="fas fa-uc"></i></Link> */}
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">IITTP Media <i className="fas fa-uc"></i></Link> */}
                    <Link to='http://intranet.iittp.ac.in/' target='_blank' className="dropdown-item nav-link">इंट्रानेट</Link>
                    <Link to='/infrastructure-at-transit-campus' className="dropdown-item nav-link">दीर्घा</Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Videos <i className="fas fa-uc"></i></Link> */}
                    <Link to='/faqs' className="dropdown-item nav-link">प्रायः पूछे जाने वाले प्रश्न</Link>
                    <Link to='/publications' className="dropdown-item nav-link">प्रकाशन</Link>
                    <Link to='/home-events-list' className="dropdown-item nav-link">आयोजन</Link>
                    <Link to='/technical-talks' className="dropdown-item nav-link">वार्ता</Link>
                    <Link to='/conferences' className="dropdown-item nav-link">सम्मेलन</Link>
                    <Link to='/workshops' className="dropdown-item nav-link">कार्यशाला</Link>

                  </div>
                </div>
              )}
            </NavDropdown>

            {/**************** 8. Recruitment ***************/}
            
              <NavDropdown
                className="align-text-top basic-nav-dropdown"
                onMouseEnter={() => handleMouseEnter("Recruitment")}
                onMouseLeave={handleMouseLeave}
                show={hoveredDropdown === "Recruitment"}
                title="कैरियर"
              >

              {/* <span className="nav-link">Recruitment</span> */}
              {hoveredDropdown === "Recruitment" && (
                // <div className="eventsNav wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                  <div className="eventsNav ">
                  <div className="has-border">
                    <Dropdown.Header>कैरियर</Dropdown.Header>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Prospective Faculty <i className="fas fa-uc"></i></Link> */}
                    <Link to='/recruitment' className="dropdown-item nav-link">संकाय पद</Link>
                    <Link to='/recruitment' className="dropdown-item nav-link">गैर शैक्षणिक पद </Link>
                    <Link to='/announcements' className="dropdown-item nav-link">परियोजनान्तर्गत  पद </Link>
                    <Link to='/announcements' className="dropdown-item nav-link">आउटसोर्सिंग पद </Link>
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Post-Doctoral Opportunities <i className="fas fa-uc"></i></Link> */}
                    {/* <Link to="/coming-soon" className="dropdown-item nav-link">Project Positions <i className="fas fa-uc"></i></Link> */}
                  </div>
                </div>
              )}
            </NavDropdown>

       
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default BasicExample;
